import axios from "axios";

const instance = axios.create({
  baseURL: process.env.FUNCTIONS_BASE_URL,
});

export default instance;
